import { router } from '@/router/router.js';

export default {
	navigateTo(path, query = {}) {
		let gotoPath = this.getGotoPath(path, query);

		let that = this;










		

			uni.navigateTo({
				url: gotoPath
			});

	},
		
	redirectTo(path, query = {}) {
		let gotoPath = this.getGotoPath(path, query);
		uni.redirectTo({
			url: gotoPath
		});
	},
	
	navigateBack(delta = 1) {
		uni.navigateBack({
			delta
		});
	},
	
	switchTab(path) {
		uni.switchTab({
			url: path,
			success(e) {
				//console.log(getCurrentPages());
			}
		});
	},
	
	getGotoPath(path, query = {}) {		
		let params;
		if(Object.keys(query).length > 0) {
			params = uni.$sk.func.object2QueryString(query);
		}
				
		if(params) {
			path += path.split('&').length == 1 ? '?' : '&';
			path += params;
		}
				
		return path;
	}
}